import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/system';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import { ButtonRectangle } from 'components/views/form/Button';

import { Box } from '@mui/material';

import { ReactComponent as Ic404 } from 'assets/icons/ic-404.svg';
import { ReactComponent as IcIturan } from 'assets/icons/ic-ituran.svg';

export const ContainerError = styled('div')(
    ({ theme }) => `
        display: flex;
        padding: 0;
        align-items: center;
        background-color: #ffffff;
        justify-content: space-between;

        h6 {
            max-width: 20rem;
            line-height: 18px;
        }

        button {
            width: 100%;
            max-width: 24rem;
            margin-top: .5rem;
            border-radius: 5px;

            background-color: transparent;
            border: 1px solid ${theme.palette.primary.main};

            :hover {
                background-color: transparent;
                border: 1px solid ${theme.palette.primary.main};
            }
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            padding: 0 0 10rem;
            justify-content: center;

            h6 {
                max-width: 45rem;
            }
        }
`)

export const TypographyTittle = styled(Typography)(
    ({ theme }) => `
        font-weight: 600;
        max-width: 19rem;
        font-size: 1.25rem;
        padding: 0 0 1rem;
        text-align: flex-start;
        
        @media(min-width: ${theme?.breakpoints.values.md}px) {
            max-width: 100%;
            font-size: 1.5rem;
            padding: 0 0 1.125rem;
        }
`)

const TypographyError404 = styled(Typography)(
    ({ theme }) => `
        color: #17A7E0;
        font-size: 4.5rem;
        font-weight: bold;
        
        @media(min-width: ${theme?.breakpoints.values.md}px) {
            font-size: 12rem;
        }
`)

const Figure = styled('figure')(
    ({ theme }) => `
    position: relative;

    margin-right: -10px;
    svg {
        position: relative;
        overflow: visible;
        z-index: 1;
        height: 180px;
        width: auto;
        top: 0px;
        left: -10px;
    }

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        svg {
            height: auto;
            left: -40px;
        }
        margin-right: 50px;
    }
`)

const BlueEllipsis = styled('div')(
    ({ theme }) => `
    background-color: #17A7E0;
    border-radius: 50%;
    position: absolute;
    z-index: 0;

    height: 282px;
    width: 282px;
    top: 76px;
    left: -180px;
  
    @media(min-width: ${theme?.breakpoints.values.md}px) {
        height: 462px;
        width: 463px;
        left: -215px;
        top: 20px;
    }
`)

const GreenEllipsis = styled('div')(
    ({ theme }) => `
    background-color: #97C93D;
    border-radius: 50%;
    position: absolute;

    width: 125px;
    height: 124px;
    top: -40px;
    right: 20px;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        height: 236px;
        width: 237px;
        top: -90px;
        right: -40px;
    }
`)

const ContainerText = styled('div')(
    ({ theme }) => `
    display: flex;
    max-width: 180px;
    flex-direction: column;
    align-items: flex-start;

    @media(min-width: ${theme?.breakpoints.values.md}px) {
        max-width: 100%;
        align-items: center;
    }
`)

const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Box sx={{ display: 'grid', gridTemplateRows: 'auto 100% auto' }}>
            <Box sx={{ width: '100%', height: '6rem', backgroundColor: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', 'svg': { maxHeight: '4.5rem' } }} >
                <IcIturan />
            </Box>
            <Container maxWidth='md' sx={{ paddingTop: '9.375rem', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ContainerError>
                    <Figure>
                        <Ic404 />
                        <BlueEllipsis />
                        <GreenEllipsis />
                    </Figure>
                    <ContainerText>
                        <TypographyError404>
                            404
                        </TypographyError404>
                        <TypographyTittle>
                            Oops, página não encontrada.
                        </TypographyTittle>
                        <ButtonRectangle name="VOLTAR AO SITE" onClick={() => navigate('/')} />
                    </ContainerText>
                </ContainerError>
            </Container>
            <Box sx={{ position: 'absolute', bottom: '0', width: '100%', height: '4rem', backgroundColor: 'primary.main', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography color='white' sx={{ fontSize: { xs: '.875rem', md: '1rem' } }}>
                    © Copyright 2023. Ituran. Todos os direitos reservados
                </Typography>
            </Box>
        </Box>
    );
}

export default NotFound;